import parse from "html-react-parser";
import { Dropdown } from "primereact/dropdown";
import React, { useRef, useReducer, useMemo } from "react";
import { QuestionType } from "components/HHQComponents";
import ViewMath from "../../ViewMath";
import "./index.css";
import { TestDetailQuizModel } from "models/test-detail.model";
interface Props {
  question: TestDetailQuizModel;
  isEdit?: boolean;
  handleUpdateQuestions?: (newValue: TestDetailQuizModel) => void;
}

const DienVaoChoTrongComponent: React.FC<Props> = ({ question, isEdit, handleUpdateQuestions }) => {
  const inputRefs = useRef<(HTMLInputElement | null)[]>([null, null, null]);
  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  const renderValueTemplate = (option?: any, placeholder?: string) => {
    return option ? (
      <div className="country-item country-item-value">
        <ViewMath>
          <div dangerouslySetInnerHTML={{ __html: option?.answer || "" }} />
        </ViewMath>
      </div>
    ) : (
      <span>{placeholder || ""}</span>
    );
  };

  const renderItemTemplate = (option?: any) => (
    <div className="country-item">
      <ViewMath>
        <div dangerouslySetInnerHTML={{ __html: option?.answer || "" }} />
      </ViewMath>
    </div>
  );

  const transform = useMemo(() => ({
    replace: (domNode: any) => {
      if (domNode.type === "text" && domNode.data.includes("[")) {
        const parts = domNode.data.split(/(\[\d+\])/);
        return (
          <React.Fragment>
            {parts.map((part: string, idx: number) => {
              const match = part.match(/[\[](\d+)[\]]/);
              if (match) {
                const index = parseInt(match[1], 10) - 1;
                return (
                  <span key={idx}>
                    {(() => {
                      if (!Array.isArray(question.userAnswer)) {
                        question.userAnswer = [];
                      }
                      const match = question.multiplePositionAnswer?.find((x) => x.answer === `[${index + 1}]`);
                      if ([QuestionType.nhieu_trinh_tha_don_xuong].includes(question.testQuestionTypeCode)) {
                        const options = match?.childQuestionAnswers || [];
                        let selectedValue = question.userAnswer[index];
                        return (
                          <Dropdown
                            value={selectedValue}
                            options={options}
                            onChange={(e) => {
                              question.userAnswer[index] = e.target.value;
                              handleUpdateQuestions?.({ ...question });
                              forceUpdate();
                            }}
                            optionValue="order"
                            optionLabel="answer"
                            className="dropdown_new_style"
                            appendTo="self"
                            placeholder="Chọn kết quả"
                            valueTemplate={(option) => renderValueTemplate(option, "Chọn kết quả")}
                            itemTemplate={renderItemTemplate}
                          />
                        );
                      }
                      let maxAnswerLength = 0;
                      if(match?.childQuestionAnswers) {
                        maxAnswerLength = Math.max(
                            ...(match?.childQuestionAnswers || [])
                                .map((item: any) => item.answer?.length || 0)
                            );
                      }
                      else if (question?.testQuestionAnswers) {
                        maxAnswerLength = Math.max(
                            ...(question?.testQuestionAnswers || [])
                                .filter((item: any) => item.isCorrect)
                                .map((item: any) => item.answer?.length || 0)
                            );
                      }
                      let anwserLength = 0;
                      if(question?.userAnswer[index]) 
                      {
                          anwserLength = question?.userAnswer[index].length;
                      }
                      if(maxAnswerLength < anwserLength) {
                          maxAnswerLength = anwserLength;
                      }
                      return (
                        <input
                          className="input_new_style"
                          ref={(el) => (inputRefs.current[index] = el)}
                          value={(question.userAnswer[index] as string) || ""}
                          style={{ width: `${8 * (maxAnswerLength || 0) + 40}px` }}
                          onChange={(e) => {
                            question.userAnswer[index] = e.target.value;
                            handleUpdateQuestions?.({ ...question });
                            forceUpdate();
                          }}
                        />
                      );
                    })()}
                  </span>
                );
              }
              return <span key={idx}>{part}</span>;
            })}
          </React.Fragment>
        );
      }
      return undefined;
    },
  }), [question]);

  return (
    <div>
      <ViewMath>{parse(question.content, transform)}</ViewMath>
    </div>
  );
};

export default React.memo(DienVaoChoTrongComponent);
